// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue';

import App from './App';
// import router from './router'
import router from './router';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lazyLoad from 'vue-lazyload';
import store from '@/store/index.js';
import Echarts from 'echarts/lib/echarts';
import VueDrag from 'vue-draggable';
import moment from 'moment';
import lodash from 'lodash';
import './assets/sass/fonts.css';
import VueClipboard from 'vue-clipboard2';

Vue.use(VueClipboard)

Vue.prototype.moment = moment
Vue.prototype.$_ = lodash
Vue.config.productionTip = false
// import LazyRender from 'vue-lazy-render'
// Vue.use(LazyRender)
import * as custom from "@/filters";
Object.keys(custom).forEach(a => {
  Vue.filter(a, custom[a])
})
Vue.use(lazyLoad, {
  preLoad: 1,
  attempt: 1
})
Vue.use(VueDrag)
Vue.use(ElementUI)
Vue.prototype.$echarts = Echarts;
Vue.prototype.$eventHub = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})
